// extracted by mini-css-extract-plugin
export var MuiPopperRoot = "bv_b6";
export var MuiTooltipPopper = "bv_b7";
export var button = "bv_cc";
export var icon = "bv_n";
export var iconWrapper = "bv_cb";
export var qlTooltipLimited = "bv_b8";
export var title = "bv_br";
export var wrapper = "bv_b9";